import { render, staticRenderFns } from "./RelatorioCotasRegiaoListFiltroModalItem.vue?vue&type=template&id=da2b14b4"
import script from "./RelatorioCotasRegiaoListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasRegiaoListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports